/* eslint-disable no-sparse-arrays */
// Modules
import { isValidCPF } from '@brazilian-utils/brazilian-utils'

// Application
import PasswordValidator, { Response } from '../passwordValidation'

export const convertToNumber = (value: string | undefined): string => (value ? value.replace(/[^0-9]/g, '') : '')

export const federalTaxIdValidator = (federalTaxId: string | undefined): boolean => {
    const formatFederalTaxId = convertToNumber(federalTaxId)
    return isValidCPF(formatFederalTaxId)
}

export const nameValidator = (name: string | undefined): boolean => {
    const values = name?.split(' ').filter(v => v !== '')
    if (values && values.length > 1) {
        return true
    }
    return false
}

export const validCharactereName = (name: string | undefined): boolean => {
    const exp = RegExp(/[^a-zà-ú-A-ZÀ-Ú *'-]/g)
    const result = !(name ? exp.test(name) : true)
    return result
}

export const minBirthDateValidator = (birthDate: string | undefined): boolean => {
    const cutoff = new Date()
    cutoff.setFullYear(cutoff.getFullYear() - 18)

    if (birthDate?.includes('*')) {
        return true
    }

    if (birthDate) {
        const [day, month, year] = birthDate?.split('/')
        const convertedBirthDate = new Date(`${month}/${day}/${year}`)
        return convertedBirthDate <= cutoff
    }
    return false
}

export const maxBirthDateValidator = (birthDate: string | undefined): boolean => {
    const cutoff = new Date('01/01/1880')

    if (birthDate?.includes('*')) {
        return true
    }

    if (birthDate) {
        const [day, month, year] = birthDate.split('/')
        const convertedBirthDate = new Date(`${month}/${day}/${year}`)
        return convertedBirthDate >= cutoff
    }
    return false
}

export const passwordValidator = (password: string): Response => {
    const validator = new PasswordValidator()
    return validator.validate(password)
}

export const classNameCheck = (
    touched: boolean | undefined,
    dirty: boolean | undefined,
    valid: boolean | undefined,
): string | undefined => {
    if (touched === undefined && !dirty) {
        return undefined
    }
    if (valid) {
        return 'success'
    }
    return 'error'
}
